import { UnitTransferJointDematCheckStatusEnumType } from '__generated__/graphql';

// NOT_CHECKED must never read as CLEAR — it means the AI check never ran (or the CML document was
// never uploaded), not that ops confirmed there is no joint account. Styled as a neutral warning,
// never as a pass, so ops doesn't mistake "we don't know" for "we checked and it's fine".
export default function unitTransferJointDematCheckStatusToReadable(
  status: UnitTransferJointDematCheckStatusEnumType
): { label: string; color: string } {
  switch (status) {
    case UnitTransferJointDematCheckStatusEnumType.NotChecked:
      return { label: 'Not Checked Yet', color: 'amber' };
    case UnitTransferJointDematCheckStatusEnumType.Clear:
      return { label: 'Clear — No Joint Account Found', color: 'green' };
    case UnitTransferJointDematCheckStatusEnumType.Detected:
      return { label: 'Joint Account Detected', color: 'red' };
    case UnitTransferJointDematCheckStatusEnumType.Unclear:
      return { label: 'Unclear — Review Manually', color: 'amber' };
    default:
      return { label: status, color: 'gray' };
  }
}
